(function (w, o, d) {
  w[o] =
    w[o] ||
    function () {
      w[o][d].push(arguments);
    };
  w[o][d] = w[o][d] || [];
})(window, "Osano", "data");

export default window.Osano;

export const removeOsanoButtons = () => {
  const buttons = window.document.querySelectorAll(
    ".osano-cm-opt-out-honored-wrapper--context_window,.osano-cm-opt-out-honored-wrapper--context_dialog",
  );
  buttons.forEach((button) => button.remove());
};
